const MARK = '/softmaya-mark.png';
const WORD = '/softmaya-word.png';

export const StaticChip = ({ className = '' }) => (
  <div className={`relative aspect-square ${className}`} data-testid="static-chip">
    <div className="absolute inset-0 rounded-full" style={{ background: 'radial-gradient(circle at 35% 30%, #222 0%, #0c0c0c 55%, #050505 100%)', boxShadow: '0 40px 80px -30px rgba(0,0,0,0.9), inset 0 0 0 2px #C8AA73' }} />
    <div
      className="absolute inset-[1%] rounded-full"
      style={{
        background: 'repeating-conic-gradient(from 11deg, #C8AA73 0deg 22deg, transparent 22deg 45deg)',
        WebkitMask: 'radial-gradient(circle, transparent 62%, #000 63%, #000 70%, transparent 71%)',
        mask: 'radial-gradient(circle, transparent 62%, #000 63%, #000 70%, transparent 71%)',
      }}
    />
    <div className="absolute inset-[17%] rounded-full border border-[#C8AA73]/80" />
    <div className="absolute inset-[22%] rounded-full border border-[#E8D6AF]/30" />
    <div className="absolute inset-0 flex flex-col items-center justify-center gap-[5%]">
      <img src={MARK} alt="SoftMaya" className="w-[28%] h-auto" />
      <img src={WORD} alt="" className="w-[36%] h-auto opacity-90" />
    </div>
    <div className="absolute inset-0 rounded-full pointer-events-none" style={{ background: 'linear-gradient(115deg, transparent 35%, rgba(244,240,232,0.08) 48%, transparent 60%)' }} />
  </div>
);

export const StaticSlot = ({ className = '' }) => (
  <div className={`relative mx-auto w-[70%] max-w-[300px] ${className}`} data-testid="static-slot">
    <div className="relative rounded-t-[28px] bg-gradient-to-b from-[#1a1a19] to-[#0d0d0d] border border-[#C8AA73]/50 h-[72px] flex items-center justify-center">
      <StaticChip className="w-[56px]" />
    </div>
    <div className="relative bg-gradient-to-b from-[#141414] to-[#0b0b0b] border-x border-[#C8AA73]/40 px-5 py-6">
      <div className="grid grid-cols-3 gap-2 rounded-xl border border-[#C8AA73] p-2 bg-[#1b1a18]/60">
        {[0, 1, 2].map((i) => (
          <div key={i} className="aspect-[3/4] rounded-md bg-[#0d0c0b] flex items-center justify-center">
            <img src={MARK} alt="" className="w-[60%]" />
          </div>
        ))}
      </div>
      <img src={WORD} alt="" className="w-[56%] mx-auto mt-6 opacity-90" />
    </div>
    <div className="h-8 rounded-b-xl bg-[#0e0e0e] border border-[#C8AA73]/40 border-t-[#E8D6AF]/60" />
  </div>
);
